import { render, staticRenderFns } from "./DiagnosisHistoryModal.vue?vue&type=template&id=76925562&"
import script from "./DiagnosisHistoryModal.vue?vue&type=script&lang=ts&"
export * from "./DiagnosisHistoryModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76925562')) {
      api.createRecord('76925562', component.options)
    } else {
      api.reload('76925562', component.options)
    }
    module.hot.accept("./DiagnosisHistoryModal.vue?vue&type=template&id=76925562&", function () {
      api.rerender('76925562', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/history/DiagnosisHistoryModal.vue"
export default component.exports